import '@banno/jha-wc/src/forms/jha-form-textarea-input/jha-form-textarea-input';
import { TmBaseComponent } from '@treasury/presentation';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { companyUserStatusConfirmationTagName as tagName } from '../../company-users.types';

@customElement(tagName)
export class UserStatusConfirmation extends TmBaseComponent {
    @state()
    private comments = '';

    public render() {
        return html`<jha-form-textarea-input
                required
                show-indicator
                type="textarea"
                rows="3"
                minlength="1"
                label="Comments"
                @change=${(e: CustomEvent) => {
                    this.comments = e.detail;
                }}
            ></jha-form-textarea-input>
            <jh-button
                ?disabled=${(this.comments?.length ?? 0) < 1}
                label="Confirm"
                appearance="primary"
                @click=${() =>
                    this.dispatchEvent(new CustomEvent('confirm', { detail: this.comments }))}
            ></jh-button>
            <jh-button
                label="Cancel"
                appearance="secondary"
                @click=${() => this.dispatchEvent(new CustomEvent('close'))}
            ></jh-button>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: UserStatusConfirmation;
    }
}
